import { axiosGet, axiosPost } from '../axios/httpRequest';
/**
 * 添加阅读通知记录
 */
export const postReadNoticeRecordApi = params => {
    return axiosPost('api/read_notice_record/phone', params);
};

export const getReadNoticeRecordApi = params => {
    return axiosGet('api/read_notice_record', params);
};

export const postReadNoticeRecordApiV2 = params => {
    return axiosPost('api/read_notice_record', params);
};
